// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tags-input .tags {
  margin-bottom: 12px;
}
.tags-input .tags .label {
  display: inline-block;
  margin-left: 2px;
  margin-right: 2px;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

.edit-tag-body {
  padding-left: 20px;
  padding-right: 20px;
}
.edit-tag-body .input-group {
  padding-top: 6px;
}`, "",{"version":3,"sources":["webpack://./../../libraries/components/dist/src/AssetLibrary/TagsInput/TagsInput.scss"],"names":[],"mappings":"AACI;EACI,mBAAA;AAAR;AACQ;EACI,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EAEA,sBAAA;EAEA,iBAAA;AACZ;;AAIA;EACI,kBAAA;EACA,mBAAA;AADJ;AAGI;EACI,gBAAA;AADR","sourcesContent":[".tags-input {\n    .tags {\n        margin-bottom: 12px;\n        .label {\n            display: inline-block;\n            margin-left: 2px;\n            margin-right: 2px;\n            cursor: pointer;\n            -webkit-touch-callout: none;\n            -webkit-user-select: none;\n            -khtml-user-select: none;\n            -moz-user-select: none;\n            -ms-user-select: none;\n            user-select: none;\n        }\n    }\n}\n\n.edit-tag-body {\n    padding-left: 20px;\n    padding-right: 20px;\n    \n    .input-group {\n        padding-top: 6px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
